import { useEffect } from 'react'
import { isScreenshotFixtureMode } from '@/shared/lib/screenshotMode'
import { useToastStore } from '@/shared/ui/toast/toastStore'

declare global {
  interface Window {
    __synapClearToasts?: () => void
  }
}

/**
 * Em build de fixtures, expõe `window.__synapClearToasts()` para o Playwright
 * limpar toasts antes de `page.screenshot()`.
 */
export function ScreenshotPlaywrightBridge() {
  useEffect(() => {
    if (!isScreenshotFixtureMode()) return
    window.__synapClearToasts = () => {
      useToastStore.setState({ toasts: [] })
    }
    return () => {
      delete window.__synapClearToasts
    }
  }, [])
  return null
}
